import { Autocomplete } from "stimulus-autocomplete"

export class Controller extends Autocomplete {
  onTabKeydown = (evt) => {
    if (!this.resultsShown) return

    if (evt.shiftKey) {
      this.onArrowUpKeydown(evt)
    } else {
      this.onArrowDownKeydown(evt)
    }
  }
}
